"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationStore = void 0;
const OrganizationBank_1 = require("../banks/OrganizationBank");
class OrganizationStore extends OrganizationBank_1.OrganizationBank {
    org(id) {
        return this.models[id];
    }
    async getOrg(id) {
        return this.resolve(id);
    }
}
exports.OrganizationStore = OrganizationStore;
